import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { LeadOwnerAssignAgentRoutes } from '../../../routes';

export const LeadOwnerAssignAgentLayout = () => {
  return <SwitchRoute routes={LeadOwnerAssignAgentRoutes} />;
};

